<template>
  <div class="tab">
    <template>
      <el-table :data="TableArray.tableData" border="border" style="width: 100%">
        <el-table-column v-for="(item, index) in TableArray.tableInfo" :key="index" :prop="item.data" :label="item.name" :width="item.width ? item.width : ''">
        </el-table-column>
        <el-table-column v-if="TableArray.details.isDetail == true" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-badge class="item" :is-dot="scope.row.m_need_edit || scope.row.s_need_edit">
              <el-button @click="tabdetails(scope.row)" type="text" >查看详情</el-button>
            </el-badge>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" v-show="TableArray.isPage">
        <el-pagination 
          :background="TableArray.page.pagebcg"
          :current-page="TableArray.page.currentPage" 
          :page-sizes="pageSizes"  
          :page-size="TableArray.page.pagemax" 
          :total="TableArray.page.pagetotal" 
          @size-change="sizeChange"
          @current-change="pageChange" 
          layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'ArTables',
  data(){
    return{
      pageSizes:[5,10,20,50], //每页显示多少条的数组
      tabsMachineInfo: this.$storage.getStorage('tabsMachineInfo') == null ? [] : this.$storage.getStorage('tabsMachineInfo'),
      tabsServeInfo: this.$storage.getStorage('tabsServeInfo') == null ? [] : this.$storage.getStorage('tabsServeInfo'),
    }
  },
  props:['TableArray'],
  methods:{
    //table详情点击事件，根据detailID划分路由跳转
    tabdetails(row){
      let detailUrl = this.TableArray.details
      if(detailUrl.isDetail == true){
        if(detailUrl.detailID == 'machineDetails'){
          let machineIp = row.m_machine_ip;
          let oldLength = this.tabsMachineInfo == null ? 0 : this.tabsMachineInfo.length;
          this.tabsMachineInfo.push(row.m_machine_ip);
          this.tabsMachineInfo = Array.from(new Set(this.tabsMachineInfo));
          let newLength = this.tabsMachineInfo.length;
          //如果相同改变active
          if(oldLength == newLength){
            this.tabsMachineInfo.map((item,index)=>{
              if(item == machineIp){
                this.$storage.setStorage('tabsMachineActive', index+1);
              }
            })
          }else{
            this.$storage.setStorage('tabsMachineInfo',this.tabsMachineInfo);
            this.tabsMachineInfo.map((item,index)=>{
              if(item == machineIp){
                this.$storage.setStorage('tabsMachineActive', index+1);
              }
            })
          }
          this.$router.push({path:'/Manage/host/'+'details' });
        }else if(detailUrl.detailID == 'serveDetails'){
          let serveid = row.s_service_id;
          let oldLength = this.tabsServeInfo == null ? 0 : this.tabsServeInfo.length;
          let isExist = false;
          if(oldLength > 0){
            this.tabsServeInfo.map((item)=>{
              if(item.id == serveid){
                isExist = true
              }
            })
            if(isExist == false){
              this.tabsServeInfo.push({ 
                id: row.s_service_id,
                ip: row.s_service_ip, 
                label: row.s_service_name
              });
            }
          }else{
            this.tabsServeInfo.push({ 
              id: row.s_service_id,
              ip: row.s_service_ip, 
              label: row.s_service_name
            });
          }

          let newLength = this.tabsServeInfo.length;
          //如果相同改变active
          if(oldLength == newLength){
            this.tabsServeInfo.map((item,index)=>{
              if(item.id == serveid){
                this.$storage.setStorage('tabsServeActive', index+1);
              }
            })
          }else{
            this.$storage.setStorage('tabsServeInfo',this.tabsServeInfo);
            this.tabsServeInfo.map((item,index)=>{
              if(item.id == serveid){
                this.$storage.setStorage('tabsServeActive', index+1);
              }
            })
          }
          this.$router.push({path:'/Manage/service/'+'details' })
        }else if(detailUrl.detailID == 'OMDetails'){
          this.$storage.setStorage('MachineIP',row.c_ip);
          this.$storage.setStorage('MachineID','');
          this.$router.push({path:'/Machine/info/'+'details'})
        }else if(detailUrl.detailID == 'OSDetails'){
          this.$storage.setStorage('ServeIDAndPID',row.c_ip+';'+row.procstat__pid);
          this.$storage.setStorage('ServeID','');
          this.$router.push({path:'/Serve/info/'+'details'})
        }else if(detailUrl.detailID == 'meetingDetails'){
          let meetingData = {
            isStart: row.m_meeting_state == '开始' ? false : true,
            roomId: row.m_meet_id,
            appId: row.m_appid
          }
          this.$storage.setStorage('meetingData', meetingData);
          this.$router.push({path:'/Meeting/manage/'+'details'})
        }
      }
    },
    //每页条数点击事件
    sizeChange(val){
      this.$emit('sizeChange',val)
    },
    //页码数点击事件
    pageChange(val){
      this.$emit('pageChange',val)
    }
  }
}
</script>

<style lang="scss" scoped>
.item{
  margin-top:3px; 
}
.has-gutter th {
  background-color: #f8f8f9;
}
  .el-table--border{
    border: 1px solid #ebeef5;
    border-right: none;
    border-bottom: none;
  }
  .tab {
    padding: 20px 20px 15px 20px;
    background-color: #FFF;
    margin: 20px 0;
    .block {
      padding-top: 20px;
      text-align: center;
      .el-pagination{
        font-size: 12px !important;
        .el-pagination__total{
          font-size: 12px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tables/tables.vue